import { api } from "./api";

export interface CurrentUser {
  id: string;
  email: string;
  displayName: string;
  roles: string[];
}

export const adminAuth = {
  login: (email: string, password: string) =>
    api.post<CurrentUser>("/admin/auth/login", { email, password }).then((r) => r.data),

  logout: () => api.post("/admin/auth/logout"),

  me: () => api.get<CurrentUser>("/admin/auth/me").then((r) => r.data),

  changePassword: (currentPassword: string, newPassword: string) =>
    api.post("/admin/auth/change-password", { currentPassword, newPassword }),

  forgotPassword: (email: string) =>
    api.post<{ message: string }>("/admin/auth/forgot-password", { email }).then((r) => r.data),

  resetPassword: (token: string, newPassword: string) =>
    api.post("/admin/auth/reset-password", { token, newPassword }),
};
